<template>
  <el-dialog
    title="修改密码"
    :before-close="handleClose"
    :visible.sync="visible"
    v-bind="utils.dialogParams().dialogProps"
  >
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      v-bind="utils.formProps()"
      class="full"
    >
      <el-form-item
        label="原密码："
        prop="oldPwd"
      >
        <el-input
          v-model.trim="ruleForm.oldPwd"
          placeholder="请输入"
          maxlength="32"
          type="password"
          show-password
        />
      </el-form-item>
      <el-form-item
        label="新密码："
        prop="newPwd"
      >
        <el-input
          v-model.trim="ruleForm.newPwd"
          placeholder="请输入"
          maxlength="32"
          type="password"
          show-password
        />
      </el-form-item>
      <el-form-item
        label="确认密码："
        prop="checkPassword"
      >
        <el-input
          v-model.trim="ruleForm.checkPassword"
          placeholder="请输入"
          maxlength="32"
          type="password"
          show-password
        />
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer form-btn"
    >
      <el-button
        @click="handleClose()"
        class="cancel"
      >取消</el-button>
      <el-button
        type="primary"
        class="save"
        :loading="saveLoading"
        @click="submitForm('ruleForm')"
      >提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import utils from "../scripts/utils";
import validate from "../scripts/validate";
import request from "../scripts/request";
import auth from "../scripts/auth";
export default {
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    const passwordSame = (rule, value, callback) => {
      if (this.ruleForm.newPwd !== this.ruleForm.checkPassword) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    };
    return {
      utils,
      ruleForm: {
        oldPwd: "",
        newPwd: "",
        checkPassword: "",
      },
      rules: {
        oldPwd: [
          {
            required: true,
            message: "请输入原密码",
            trigger: ["blur", "change"],
          },
          // {
          //   message: "密码为20-32位字母、数字、特殊字符两两组合",
          //   pattern: validate.passwordPattern(),
          //   trigger: ["blur", "change"],
          // },
          // password,
        ],
        newPwd: [
          {
            required: true,
            message: "请输入新密码",
            trigger: ["blur", "change"],
          },
          {
            message: "密码为20～30位大小写字母、数字、特殊字符至少三种组合",
            pattern: validate.passwordPattern(),
            trigger: ["blur", "change"],
          },
          // password,
        ],
        checkPassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: ["blur", "change"],
          },
          {
            message: "密码为20～30位大小写字母、数字、特殊字符至少三种组合",
            pattern: validate.passwordPattern(),
            trigger: ["blur", "change"],
          },
          // password,
          {
            required: true,
            validator: passwordSame,
            trigger: ["blur", "change"],
          },
        ],
      },
      saveLoading: false,
    };
  },
  methods: {
    handleClose(flag) {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.$emit("update:visible", false);
      if (flag == 1) {
        this.$emit("change");
      }
    },
    /**表单提交 */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveLoading = true;
          utils.formTrim(this.ruleForm);
          let ruleForm = { ...this.ruleForm };
          ruleForm.oldPwd = utils.doEncrypt(this.ruleForm.oldPwd);
          ruleForm.newPwd = utils.doEncrypt(this.ruleForm.newPwd);
          ruleForm.checkPassword = utils.doEncrypt(
            this.ruleForm.checkPassword
          );
          request({
            url: "/portal/api/v1/user/modify",
            method: "post",
            data: {
              oldPwd: ruleForm.oldPwd,
              newPwd: ruleForm.newPwd,
            },
          })
            .then((res) => {
              if (res.code === "00000") {
                this.$message.success({
                  message: "密码修改成功",
                });
                auth.removeToken();
                this.handleClose(1);
                this.saveLoading = false;
              } else {
                this.saveLoading = false;
              }
            })
            .catch(() => {
              this.saveLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style></style>
